import { IWorkspaceUser } from 'src/@types/workspace-info';
import { axios } from 'src/utils/axios';

export enum Rule {
  ADMINISTRATOR = 'administrator',

  /** Role */
  ROLES_VIEW = 'role.view',
  ROLES_EDIT = 'role.edit',
  ROLES_DELETE = 'role.delete',

  /** Mock */
  MOCK_DENIED = 'mock.denied',
  MOCK_ALLOW = 'mock.allow',
}

export type IRole = {
  _id: string;
  name: string;
  color: string;
  description: string;
  rules: Rule[];
  users: IWorkspaceUser[];
};

export async function getRoles(): Promise<IRole[]> {
  const { data } = await axios.get(`/roles`);
  return data;
}

type CreateRolePayload = Required<Omit<IRole, '_id' | 'users'>> & {
  users?: string[];
};
export async function createRole(payload: CreateRolePayload): Promise<IRole> {
  const { data } = await axios.post(`/roles/create`, payload);
  return data;
}

type UpdateRolePayload = {
  id: string;
} & Omit<IRole, '_id' | 'users'>;
export async function updateRole(payload: UpdateRolePayload): Promise<IRole> {
  const { data } = await axios.put(`/roles/update`, payload);
  return data;
}

export async function deleteRole(id: string): Promise<IRole> {
  const { data } = await axios.delete(`/roles/delete?id=${id}`);
  return data;
}

export * as RolesRequests from './roles.requests';
